import * as R from 'remeda';

import { CODE_NAME_SEPARATOR, HIERARCHY_SEPARATOR } from './separators';

type CodeNamePair = [string | null | undefined, string | null | undefined];

/**
 * コード・名称ペアの配列をフォーマットして表示文字列を生成
 * 例: [[kan_code, kan_name], [ko_code, ko_name]] → "01:総務費 / 02:企画費"
 */
export const formatCodeNamePairs = (pairs: CodeNamePair[]): string | undefined =>
  R.pipe(
    pairs,
    R.filter(([code, name]) => !!(code && name)),
    R.map(([code, name]) => `${code}${CODE_NAME_SEPARATOR}${name}`),
    R.join(HIERARCHY_SEPARATOR),
  ) || undefined;
